import { useQuery } from "@tanstack/react-query";
import { subscriptionsApi } from "@/shared/api/subscriptions/api-subscriptions";
import type { UserSubscription } from "@/shared/api/types";

interface UseSubscriptionsReturn {
  subscriptions: UserSubscription[];
  isLoading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export const useSubscriptions = (): UseSubscriptionsReturn => {
  const {
    data,
    isLoading,
    error: queryError,
    refetch,
  } = useQuery({
    ...subscriptionsApi.getSubscriptionsQueryOptions(),
    retry: 2,
  });

  return {
    subscriptions: data || [],
    isLoading,
    error: queryError?.message || null,
    refetch: async () => {
      await refetch();
    },
  };
};
